/**
 * Scan & Pay memory, kept in this browser only (cleared on logout with the
 * rest of localStorage). Same keys and shape as the Flutter app's PayMemory.
 */

const RECENT_KEY = 'scan_pay_recent_payees';
const PENDING_KEY = 'scan_pay_pending';
const MAX_RECENT = 12;

const read = (key) => {
  try {
    return JSON.parse(localStorage.getItem(key));
  } catch {
    return null;
  }
};

const write = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // Storage full or blocked: Scan & Pay still works, it just forgets.
  }
};

/** [{ vpa, name, categoryId, accountId, lastPaidAt }], newest first. */
export function getRecentPayees() {
  const list = read(RECENT_KEY);
  if (!Array.isArray(list)) return [];
  return list
    .filter((p) => p && typeof p.vpa === 'string')
    .sort((a, b) => (b.lastPaidAt || 0) - (a.lastPaidAt || 0));
}

export function findRecentPayee(vpa) {
  const key = (vpa || '').trim().toLowerCase();
  if (!key) return null;
  return getRecentPayees().find((p) => p.vpa.toLowerCase() === key) || null;
}

export function rememberPayee({ vpa, name, categoryId, accountId }) {
  const key = vpa.trim().toLowerCase();
  const previous = findRecentPayee(vpa);
  const rest = getRecentPayees().filter((p) => p.vpa.toLowerCase() !== key);
  const entry = {
    vpa: vpa.trim(),
    name: (name || '').trim() || previous?.name || null,
    categoryId: categoryId || null,
    accountId: accountId || null,
    lastPaidAt: Date.now()
  };
  write(RECENT_KEY, [entry, ...rest].slice(0, MAX_RECENT));
}

/** The first web version kept an unconfirmed payment here; it is only cleared now. */
export function clearLegacyPending() {
  try {
    localStorage.removeItem(PENDING_KEY);
  } catch {
    // ignore
  }
}
